import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.2.285a1 1 0 0 0-1.4 1.43L15.23 8H.999a1 1 0 1 0 0 2h13.95l-6.164 6.3a1 1 0 1 0 1.43 1.4l8-8.179a1 1 0 0 0-.016-1.414z"
    }, null, -1)
  ]))]))
}
export default { render: render }